var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item form-item_groupped",class:{'form-item_groupped_required': _vm.required}},[_c('label',{attrs:{"for":_vm.name}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }